import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconArrowBackUp, IconArrowForwardUp } from '@tabler/icons-react';

export interface TextEntryHistoryButtonsProps {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

/** Undo/redo controls shared by plain and rich questionnaire text fields. */
export function TextEntryHistoryButtons({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
}: TextEntryHistoryButtonsProps): JSX.Element {
  return (
    <Group gap={2} wrap="nowrap">
      <Tooltip label="Undo (Ctrl+Z)" withArrow>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          aria-label="Undo"
          disabled={!canUndo}
          onMouseDown={(event) => {
            event.preventDefault();
            onUndo();
          }}
        >
          <IconArrowBackUp size={14} />
        </ActionIcon>
      </Tooltip>
      <Tooltip label="Redo (Ctrl+Shift+Z)" withArrow>
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          aria-label="Redo"
          disabled={!canRedo}
          onMouseDown={(event) => {
            event.preventDefault();
            onRedo();
          }}
        >
          <IconArrowForwardUp size={14} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}

/** @deprecated Use TextEntryHistoryButtons */
export function TextEntryUndoButton({
  canUndo,
  onUndo,
}: {
  canUndo: boolean;
  onUndo: () => void;
}): JSX.Element {
  return (
    <TextEntryHistoryButtons
      canUndo={canUndo}
      canRedo={false}
      onUndo={onUndo}
      onRedo={() => {}}
    />
  );
}
